import { Donuz } from "donuz-js/Donuz";
// @ is an alias to /src
export default {
    name: "invite",
    data() {
        return {
            obj: {},
            urlshare: "",
            email: ""
        };
    },
    async created() {
        this.obj = await this.getAdmins();
        this.obj = this.obj.estabelecimentos[0];
        this.client = JSON.parse(atob(sessionStorage.getItem(btoa("cliente"))));
        this.urlshare = `http://comunidade.trilhacervejaria.com.br/`;
    },
    methods: {
        submit: async function() {
            let message = await Donuz.mail.getEmailInvite();
            message = this.replaceTags(message, this.urlshare);
            message.to = this.email;
            message.mensagem = message.email;
            message.estabelecimento = this.obj.id
            let result = await Donuz.mail.sendMail(message);
            if (result.status == 200) {
                M.toast({ html: result.mensagem, classes: "green" });
            } else {
                M.toast({ html: result.mensagem, classes: "red" });
            }
        },
        copy() {
            var copyText = document.getElementById("ptsvc");
            copyText.select();
            copyText.setSelectionRange(0, 99999); /*For mobile devices*/
            document.execCommand("copy");
            M.toast({ html: "Link copiado!", classes: "green" });
        },
        replaceTags: function(dados, $link) {
            let substituicoes = {
                // dados do membro
                "{nome_membro}": this.client.nome,
                "{codigo_membro}": this.client.codigo,
                "{cpf_membro}": this.client.cpf,
                "{login_membro}":
                    (!this.empty(this.client.cpf) ? this.client.cpf : "") +
                    (!this.empty(this.client.codigo) && !this.empty(this.client.cpf) ?
                        " ou " :
                        "") +
                    (!this.empty(this.client.codigo) ? this.client.codigo : ""),
                "{segundo_nome_membro}": this.client.sobrenome,
                "{foto_membro}": this.client.foto,
                "{endereco_membro}": this.client.endereco,
                "{numero_membro}": this.client.numero,
                "{complemento_membro}": this.client.complemento,
                "{bairro_membro}": this.client.bairro,
                "{cidade_membro}": this.client.cidade,
                "{estado_membro}": this.client.estado,
                "{cep_membro}": this.client.cep,
                "{data_nascimento_membro}": this.client.data_nascimento,
                "{sexo_membro}": this.client.sexo,
                "{link_indique}": $link,

                // pontos
                "{saldo_pontos_membro}": this.client.saldo ? this.client.saldo : 0,
                "{saldo}": this.client.saldo ? this.client.saldo : 0
            };
            Object.entries(substituicoes).map(val => {
                dados.email = dados.email.replace(val[0], val[1]);
                dados.assunto = dados.assunto.replace(val[0], val[1]);
            });
            return dados;
        },
        empty: function(data) {
            return data == null || data == undefined || data.toString().trim() == "";
        }
    }
};